import { UserModel } from "../../auth/models/user.model";

export class UserUtils {
  static findUserColorByEmail(users: UserModel[], email: string): string {
    let color = users.find(u => u.email === email)?.color;
    if (!color) {
      color = '#000000';
    }
    return color;
  }

  static findUserFieldByEmail(users: UserModel[], email: string, field: string): string {
    let fieldValue: any = users.find(u => u.email === email)
    if(fieldValue){
      fieldValue = fieldValue[field];
      return fieldValue;
    }
    
    return "";
  }

  static findUserByEmail(users: UserModel[], email: string): UserModel | undefined {
    return users.find(u => u.email === email);
  }

  static findUserByUsername(users: UserModel[], username: string): UserModel | undefined {
    return users.find(u => u.username === username);
  }
}
